import { ANY_PHONE, PDF_FILE_TYPE, CSV_FILE_TYPE, XLSX_FILE_TYPE, PNG_FILE_TYPE, GIF_FILE_TYPE, JPG_FILE_TYPE, JPEG_FILE_TYPE, HEIC_EXTENSION } from 'constants/values';


export const hasTextValue = (value) => {
    return typeof value === 'string'  && value.trim() !== '';
}

export const hasNoTextValue = (value) => {

    return !hasTextValue(value);
}

export const hasValue = (value) => {
    return value == null ? false : typeof value === 'string' ? value.trim() !== '' : true;
}

export const hasNoValue = (value) => {

    return !hasValue(value);
}

export const isNoDateText = (value) => {

    return hasNoTextValue(value) ? false : value.startsWith('01/01/0001') || value.startsWith('0001-01-01');
}

export const hasNoDateValue = (value) => {

    return hasNoTextValue(value) || isNoDateText(value);
}

export const arrayHasLength = (value) => {

    return Array.isArray(value) && value.length > 0;
}

export const arrayHasNoLength = (value) => {

    return !arrayHasLength(value)
}

export const isPhone = (value) => {
    return ANY_PHONE.test(value);
}

export const isNotPhone = (value) => {
    return !isPhone(value);
}

export const isFileType = (fileType, file) => {
    return file == null ? false : file.type === fileType;
}

export const isPdfFile = (file) => {
    return isFileType(PDF_FILE_TYPE, file);
}

export const isXlsxFile = (file) => {
    return isFileType(XLSX_FILE_TYPE, file);
}

export const isCsvFile = (file) => {
    return isFileType(CSV_FILE_TYPE, file);
}

export const isPngFile = (file) => {
    return isFileType(PNG_FILE_TYPE, file);
}

export const isGifFile = (file) => {
    return isFileType(GIF_FILE_TYPE, file);
}

export const isJpgFile = (file) => {
    return isFileType(JPG_FILE_TYPE, file);
}

export const isJpegFile = (file) => {
    return isFileType(JPEG_FILE_TYPE, file);
}

export const isHeicFile = (file) => {
    return file == null ? false : hasTextValue(file.name) && file.name.toLowerCase().endsWith(HEIC_EXTENSION);
}

export const isCertificationFileType = (file) => {
    return isPdfFile(file) ||
           isPngFile(file) ||
           isGifFile(file) ||
           isJpgFile(file) ||
           isJpegFile(file) ||
           isHeicFile(file)
}

export const isNotCertificationFileType = (file) => {
    return !isCertificationFileType(file);
}
